<template>
    <div class="my-ui-xxbb-my-form-body">
        <slot></slot>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.my-ui-xxbb-my-form-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}
</style>